import { FC } from 'react'

import { trueOrUndefined } from '@trustycars/genie-ui/functions'
import { Icon } from '@trustycars/genie-ui/icons/Icon'

import useSignal from '$actions/useSignal'
import { passwordRules } from '$store/settings'

import { icon, items, list, text } from './styles.css'

export type PasswordRulesProps = {
  disabled?: boolean
  invalidRules: string[]
}

export const PasswordGuide: FC<PasswordRulesProps> = ({
  invalidRules,
  disabled
}) => {
  const rules = useSignal(passwordRules)
  const formatted = rules
    .map(({ regex, ...rest }) => ({
      id: `${regex}`,
      ...rest
    }))
    .map(({ id, ...rest }) => ({
      id,
      invalid: disabled || invalidRules.includes(id),
      ...rest
    }))

  return (
    <ul className={list}>
      {formatted.map(({ id, description, invalid }) => (
        <li key={id} data-invalid={trueOrUndefined(invalid)} className={items}>
          <Icon
            namespace={invalid ? 'Warning' : 'TickCircle'}
            className={icon}
          />
          <span className={text}>{description}</span>
        </li>
      ))}
    </ul>
  )
}

export default PasswordGuide
